import gsap from 'gsap'
import SplitText from 'gsap/dist/SplitText'
import { forEach } from 'lodash'

export type Motion = {
  timeline: GSAPTween | GSAPTimeline
  revert: () => void
}

export const getScrollTriggerOptions = (vars?: ScrollTrigger.StaticVars) => {
  return {
    start: 'top 90%',
    end: 'bottom top',
    toggleActions: 'play none none reverse',
    markers: false,
    once: true,
    ...vars
  }
}

export const createSplitTextLines = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, { type: 'lines', mask: 'lines' })
  forEach(splitText.lines, (line) => {
    if (line.innerHTML.length === 0) {
      line.innerHTML = '&nbsp;'
    }
  })
  return splitText
}

export const createLinesMotion = (target: gsap.DOMTarget) => {
  const splitText = createSplitTextLines(target)
  const timeline = gsap.from(splitText.lines, {
    yPercent: 100,
    duration: 0.6,
    ease: 'power2.out',
    stagger: {
      amount: 0.15
    }
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}

export const createScrubWordsMotion = (target: gsap.DOMTarget) => {
  const splitText = SplitText.create(target, {
    type: 'words',
    linesClass: 'line',
    wordsClass: 'word'
  })
  const timeline = gsap.from(splitText.words, {
    opacity: 0.1,
    duration: 0.8,
    ease: 'power3.out',
    stagger: {
      amount: 0.2
    }
  })

  const revert = () => {
    splitText.revert()
  }

  return {
    timeline,
    revert
  }
}
